'use es6';

import { Map as ImmutableMap } from 'immutable';
import { makeOption } from '../Option';
import { STATIC_INTEGRATION_DATA } from './staticIntegrationData';
const options = ImmutableMap(STATIC_INTEGRATION_DATA).map((value, key) => makeOption(key, value));
export default (() => Promise.resolve(options));